import { render, staticRenderFns } from "./InventarioTable.vue?vue&type=template&id=1405a3da&scoped=true&"
import script from "./InventarioTable.vue?vue&type=script&lang=js&"
export * from "./InventarioTable.vue?vue&type=script&lang=js&"
import style0 from "./InventarioTable.vue?vue&type=style&index=0&id=1405a3da&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1405a3da",
  null
  
)

export default component.exports